import React, { useState, useEffect } from 'react'
import { Row, Col } from 'antd'
import { Form, Input, Button, Modal } from 'antd'
import { UserOutlined, LockOutlined } from '@ant-design/icons'
import { login, loginCustomer, storeCredentials } from '../../../services/lib/utils/auth.utils'
import { LoginRequest } from '../../../services/others/login-services'
import './login.css'
import { useHistory } from 'react-router-dom'
import { ApiRequest } from '../../../services/api/api'

function Login(props: any) {
  const history = useHistory()

  const [errorMsg, setErrorMsg] = useState<any>()
  const [isLoading, setIsLoading] = useState(false)
  const [userType, setUserType] = useState<'1' | '2'>(
    JSON.parse(localStorage.getItem('USER_TYPE')!) 
      ? JSON.parse(localStorage.getItem('USER_TYPE')!) 
      : '1'
  )

  // Show a message when the user was redirected here by an expired session (401)
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('expired') === '1') {
      setErrorMsg('Session expired, please sign in again / 登录已过期，请重新登录')
    }
  }, [])

  const onFinish = (values: any) => {
    values.type = userType
    console.log('Received values of form: ', values)
    
    if (values.type === '1') {
      setIsLoading(true)
      localStorage.setItem('USER_TYPE', '"1"')
      setTimeout(() => {
        LoginRequest(values)
          .then(res => {
            setIsLoading(false)
            console.log(res)
            let filteredPages = res.data.data;
            filteredPages.pages = res.data.data.pages.filter((page: any) => {
              if (page.group) {
                return page.group.groupName !== "Mobile";
              }
              return true;
            });

            // 保存用户凭据用于后续刷新token
            storeCredentials(values.username, values.password)

            login(filteredPages, () => {
              history.push('/home')
            })
          })
          .catch(err => {
            setIsLoading(false)
            console.log(err)
            if (err?.data?.message?.message) {
              setErrorMsg(err?.data?.message?.message)
            }
          })
      }, 1500)
    }
    
    if (values.type === '2') {
      setIsLoading(true)
      localStorage.setItem('USER_TYPE', '"2"')
      setTimeout(() => {
        ApiRequest({
          url: 'OnlineUser/OnlineUserLogin',
          method: 'post',
          data: values
        })
          .then(res => {
            setIsLoading(false)
            console.log(res)
            loginCustomer(res.data.data, () => {
              history.push('/sales-order-management-for-customer')
            })
          })
          .catch(err => {
            setIsLoading(false)
            console.log(err)
            if (err?.data?.message?.message) {
              setErrorMsg(err?.data?.message?.message)
            }
          })
      }, 1500)
    }
  }

  const info = () => {
    Modal.info({
      title: 'Forgot Password',
      content: (
        <div>
          <br />
          <p>Please contact Jadcup customer service</p>
        </div>
      ),
      onOk() { },
    })
  }

  const switchUserType = () => {
    console.log('user type is changed')
    if (userType === '1') {
      setUserType('2')
    } else {
      setUserType('1')
    }
    console.log('user type: ' + userType)
  }

  return (
    <div style={{ height: '100vh', background: 'linear-gradient(135deg, #f5f7f5 0%, #e8f0ed 100%)' }}>
      <Row style={{ height: '100%' }}>
        {/* Left Panel - Hero Section */}
        <Col xs={0} md={14} lg={15} style={{ 
          position: 'relative',
          background: `linear-gradient(135deg, rgba(26, 58, 42, 0.95) 0%, rgba(26, 58, 42, 0.75) 100%), url('https://jadcup.co.nz/wp-content/uploads/2023/05/Jadcup-Slider-Design-Cups.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px',
          animation: 'slideIn 0.8s ease-out'
        }}>
          <div style={{ 
            color: 'white', 
            textAlign: 'center',
            maxWidth: '600px',
            animation: 'fadeInUp 1s ease-out'
          }}>
            <h1 style={{ 
              fontSize: '3.5rem', 
              fontWeight: '700', 
              marginBottom: '20px',
              color: '#8fcaad',
              textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
            }}>
              Welcome to Jadcup
            </h1>
            <p style={{ 
              fontSize: '1.3rem', 
              lineHeight: '1.8',
              color: '#ffffff',
              opacity: 0.95,
              fontWeight: '300'
            }}>
              Your trusted partner for premium sustainable cup solutions
            </p>
          </div>
          
          <div style={{ 
            position: 'absolute', 
            bottom: '30px', 
            left: '50%', 
            transform: 'translateX(-50%)', 
            textAlign: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
            fontSize: '13px'
          }}>
            <a 
              href="https://spiritx.co.nz" 
              target="_blank" 
              rel="noopener noreferrer" 
              style={{ 
                color: '#8fcaad',
                textDecoration: 'none',
                transition: 'color 0.3s'
              }}
            >
              Powered by spiritx
            </a>
          </div>
        </Col>

        {/* Right Panel - Login Form */}
        <Col xs={24} md={10} lg={9} style={{ 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '40px 20px',
          background: 'white',
          animation: 'fadeIn 0.8s ease-out'
        }}>
          <div style={{ 
            width: '100%',
            maxWidth: '420px'
          }}>
            {/* Logo Section - Larger, positioned at top */}
            <div style={{ textAlign: 'center', marginBottom: '50px' }}>
              <img 
                src="https://jadcup.co.nz/wp-content/uploads/2023/03/logo-1.png" 
                alt="Jadcup Logo"
                style={{ height: '70px', marginBottom: '0' }} 
              />
            </div>

            {/* Title Badge */}
            <div style={{ textAlign: 'center', marginBottom: '35px' }}>
              <div style={{
                display: 'inline-block',
                padding: '10px 32px',
                background: userType === '1' 
                  ? 'linear-gradient(135deg, #1a3a2a 0%, #2d5a45 100%)' 
                  : 'linear-gradient(135deg, #faad14 0%, #ffc53d 100%)',
                borderRadius: '30px',
                boxShadow: '0 4px 15px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease'
              }}>
                <h2 style={{ 
                  margin: 0,
                  color: 'white',
                  fontSize: '1.4rem',
                  fontWeight: '600'
                }}>
                  {userType === '1' ? 'Staff Login' : 'Customer Login'}
                </h2>
              </div>
            </div>

            {/* Login Form */}
            <div style={{
              background: 'white',
              padding: '30px',
              borderRadius: '16px',
              boxShadow: '0 8px 30px rgba(26, 58, 42, 0.08)'
            }}>
              <Form
                name="normal_login"
                initialValues={{ remember: true }}
                onFinish={onFinish}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: 'Please input your Username!' }]}
                >
                  <Input 
                    prefix={<UserOutlined style={{ color: '#8fcaad', fontSize: '18px' }} />} 
                    placeholder="Username"
                    style={{
                      height: '48px',
                      borderRadius: '8px',
                      fontSize: '15px',
                      border: '2px solid #e8f0ed',
                      transition: 'all 0.3s'
                    }}
                  />
                </Form.Item>

                <Form.Item
                  name="password"
                  {...errorMsg && { help: errorMsg, validateStatus: 'error' }}
                  rules={[{ required: true, message: 'Please input your Password!' }]}
                >
                  <Input.Password
                    prefix={<LockOutlined style={{ color: '#8fcaad', fontSize: '18px' }} />}
                    type="password"
                    placeholder="Password"
                    style={{
                      height: '48px',
                      borderRadius: '8px',
                      fontSize: '15px',
                      border: '2px solid #e8f0ed',
                      transition: 'all 0.3s'
                    }}
                  />
                </Form.Item>

                <Form.Item style={{ marginBottom: 0 }}>
                  <Button 
                    loading={isLoading} 
                    type="primary" 
                    htmlType="submit"
                    style={{ 
                      width: '100%',
                      height: '50px',
                      borderRadius: '8px',
                      fontSize: '16px',
                      fontWeight: '600',
                      border: 'none',
                      background: userType === '1' 
                        ? 'linear-gradient(135deg, #1a3a2a 0%, #2d5a45 100%)' 
                        : 'linear-gradient(135deg, #faad14 0%, #ffc53d 100%)',
                      boxShadow: userType === '1'
                        ? '0 6px 20px rgba(26, 58, 42, 0.3)'
                        : '0 6px 20px rgba(250, 173, 20, 0.3)',
                      transition: 'all 0.3s'
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-2px)'
                      e.currentTarget.style.boxShadow = userType === '1'
                        ? '0 8px 25px rgba(26, 58, 42, 0.4)'
                        : '0 8px 25px rgba(250, 173, 20, 0.4)'
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)'
                      e.currentTarget.style.boxShadow = userType === '1'
                        ? '0 6px 20px rgba(26, 58, 42, 0.3)'
                        : '0 6px 20px rgba(250, 173, 20, 0.3)'
                    }}
                  >
                    {userType === '1' ? 'Staff Log in' : 'Customer Log in'}
                  </Button>
                </Form.Item>
              </Form>
            </div>

            {/* Switch User Type Section - Larger and more prominent */}
            <div style={{ 
              margin: '40px 0', 
              textAlign: 'center',
              padding: '25px',
              background: 'linear-gradient(135deg, #f8faf9 0%, #f0f5f3 100%)',
              borderRadius: '16px',
              border: '2px solid #e8f0ed'
            }}>
              <div style={{
                fontSize: '17px',
                color: '#5a5a5a',
                marginBottom: '15px',
                fontWeight: '500'
              }}>
                {userType === '1' ? 'Not a staff member?' : 'Not a customer?'}
              </div>
              <div 
                style={{ 
                  color: userType === '1' ? '#faad14' : '#1a3a2a',
                  cursor: 'pointer',
                  fontSize: '20px',
                  fontWeight: '700',
                  padding: '14px 28px',
                  borderRadius: '10px',
                  transition: 'all 0.3s',
                  display: 'inline-block',
                  background: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.08)'
                }}
                onClick={switchUserType}
                onMouseEnter={(e) => {
                  e.currentTarget.style.background = userType === '1' ? '#fff7e6' : '#e8f0ed'
                  e.currentTarget.style.transform = 'translateY(-2px)'
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.12)'
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.background = 'white'
                  e.currentTarget.style.transform = 'translateY(0)'
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(0,0,0,0.08)'
                }}
              >
                {userType === '1' ? 'Switch to Customer Login →' : 'Switch to Staff Login →'}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Custom Styles */}
      <style>{`
        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideIn {
          from {
            transform: translateX(-100%);
          }
          to {
            transform: translateX(0);
          }
        }

        .ant-input:focus,
        .ant-input-password:focus,
        .ant-input-affix-wrapper:focus,
        .ant-input-affix-wrapper-focused {
          border-color: #8fcaad !important;
          box-shadow: 0 0 0 2px rgba(143, 202, 173, 0.1) !important;
        }

        .ant-input:hover,
        .ant-input-password:hover,
        .ant-input-affix-wrapper:hover,
        .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
          border-color: #8fcaad !important;
        }

        .ant-input-affix-wrapper {
          border: 2px solid #e8f0ed;
          border-radius: 8px;
          transition: all 0.3s;
        }

        @media (max-width: 768px) {
          h1 {
            font-size: 2.5rem !important;
          }
          
          p {
            font-size: 1.1rem !important;
          }
        }
      `}</style>
    </div>
  )
}

export default Login
